module.exports = __webpack_public_path__ + "img/img_chengban@2x.e4829469.png";